import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared';
import { NotificationListComponent } from './components/notification-list/notification-list.component';
import { TaskListComponent } from './components/task-list/task-list.component';
import { NotificationMenuComponent } from './notification-menu.component';
import { TypeIconPipe } from './pipes/type-icon.pipe';

@NgModule({
  imports: [SharedModule, RouterModule],
  declarations: [
    NotificationMenuComponent,
    NotificationListComponent,
    TaskListComponent,
    TypeIconPipe
  ],
  exports: [
    NotificationMenuComponent,
    NotificationListComponent,
    TaskListComponent
  ]
})
export class NotificationMenuModule {}
